/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PageInfo } from "./PageInfo";
import { Archetype } from "./Archetype";
import * as t from "io-ts";

/**
 * The paginated list of archetypes.
 */

// required attributes
const ArchetypeListR = t.interface({
  page_info: PageInfo,

  resources: t.readonlyArray(Archetype, "array of Archetype")
});

// optional attributes
const ArchetypeListO = t.partial({});

export const ArchetypeList = t.intersection(
  [ArchetypeListR, ArchetypeListO],
  "ArchetypeList"
);

export type ArchetypeList = t.TypeOf<typeof ArchetypeList>;
